module.exports = __webpack_public_path__ + "img/arrow-left-carousel.d4f7f504.svg";